import React from 'react';
import UserCard from '../components/user/UserCard';

const Profile = () => {
  return (
    <div className="flex-1 flex flex-col overflow-hidden min-h-screen bg-gray-200">
      <main className="flex-1 overflow-x-hidden overflow-y-auto p-6">
        <div className="max-w-4xl mx-auto">
          <div className="mb-6 text-center">
            <h1 className="text-2xl font-semibold text-gray-900">Профиль</h1>
            <p className="text-gray-600">Управление настройками профиля</p>
          </div>
          <UserCard />
        </div>
      </main>
    </div>
  );
};

export default Profile; 